<template>
    <div>



        <div class="row mt-5">
            <div class="col-sm-12">
                <template v-if="type == 'bankinfo'">
                    Download template for new import or use the already exported template for bulk primary account update.
                </template>
                <template v-else>
                    <template >Download the bulk import template and import
                        <template v-if="type == 'ait'">AIT</template>
                        <template v-else-if="type == 'migrated-payroll'">Migrated Payroll Histyory</template>
                        <template v-else-if="type == 'migrated-pf'">Migrated PF Histyory</template>
                        <template v-else>Investment</template>(s) accordingly.
                    </template>
                </template>
            </div>
            <div class="col-sm-12 mt-2">
                <a :href="'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
                <!-- Abdullah26 added mr-2  -->
                <b-button @click="downloadTemplate(1)" class="btn btn-primary rounded float-left mr-2"><b-icon icon="code-slash" ></b-icon> Download Template For Active Employees</b-button>
                <b-button @click="downloadTemplate(0)" class="btn btn-primary rounded float-left mx-2"><b-icon icon="code-slash" ></b-icon> Download Template For Inactive Employees</b-button>
            </div>
        </div>


        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />

            <div v-if='errormsg'>
                <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                <ul class="list-group mt-4">
                    <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                </ul>
            </div>

        </b-overlay>
  </div>
</template>
<script>

    export default{

        mounted() {
            //console.log('Bank info started..');
            //console.log(this.employee_id);
            //alert(this.cu);
        },
        props: ['type' ],
        data(){

            return {

                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                upload_url : '',
                process_url : '',

                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                showoverlay : false,

            }
        },
        methods:{
            downloadTemplate(f = 0)
            {
                let currentObj = this;
                let formData = new FormData();
                //formData.append('employee_ids', this.selected);

                if(this.type == 'investment')
                    formData.append('flg', 1);
                else if(this.type == 'bankinfo')
                {
                    formData.append('flg', 3);
                }
                else if(this.type == 'migrated-payroll')
                    formData.append('flg', 4);
                else if(this.type == 'migrated-pf')
                    formData.append('flg', 5);
                else
                    formData.append('flg', 2);

                formData.append('employee_status', f);

                axios.post(this.$api_url+'/employee/export-for-update', formData)
                    .then(function (response)
                    {
                        //this.showoverlay = false;

                        var fileURL = response.data;

                        this.downloadFileContent(fileURL);

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            setUrls:function()
            {
                this.upload_url = this.$api_url+"/employee/import/data";
                this.process_url = this.$api_url+'/employee/import/data/processdata';

            },
            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                this.showoverlay = true;
                this.show_employee_list = false;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);
                data.append('type', this.type);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                        this.showoverlay = false;

                        setTimeout("location.href = '"+"/employee';",1500);

                    }.bind(this)).
                    catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed numeric value encountered.' , {
                                                title: `Data Template Error`,
                                                variant: 'danger',
                                                solid: true
                                            });
                    });
            },


        },

        created: function(){
            this.setUrls();

        },
    }
</script>
